import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Stack, Typography, Grid } from '@mui/material';
import { InputText } from 'app/components/elements/InputText';
import { FormPostSeizure } from './modules/FormPostSeizure/FormPostSeizure';
import CustomDatePicker from '../../../../../components/elements/InputDate';
import dayjs from 'dayjs';

const InsuranceDetailSection: React.FC = () => {
  const {
    control,
    register,
    formState: { errors }
  } = useFormContext<FormPostSeizure>();

  return (
    <Stack>
      <Typography style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>
        Insurance Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            title="Provider"
            placeholder="Enter provider"
            inputError={errors?.insuranceDetail?.provider?.message as string}
            inputProps={{
              ...register('insuranceDetail.provider')
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            title="Policy"
            placeholder="Enter policy"
            inputError={errors?.insuranceDetail?.policyNumber?.message as string}
            inputProps={{
              ...register('insuranceDetail.policyNumber')
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Controller
            name={'insuranceDetail.expiry'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <CustomDatePicker
                inputError={errors?.insuranceDetail?.expiry?.message}
                title={'Expiry'}
                value={value ? dayjs(value) : null}
                onChange={onChange}
                datePickerProps={{}}
              />
            )}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default InsuranceDetailSection;
